import React from "react";
import { Container, Typography, Box, Paper } from "@mui/material";
import Navbar from "../../Components/Common/Navbar";
import Footer from "../../Components/Common/Footer";

function RefundPolicy() {
    return (
        <Box display="flex" flexDirection="column" minHeight="100vh">
            <Navbar />
            <Box component="main" flex="1">
                <Container maxWidth="md" sx={{ mt: 7, mb: 4 }}>
                    <Paper elevation={3} sx={{ p: 3 }}>
                        <Typography variant="h4" component="h1" gutterBottom>
                            Refund Policy
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            At TravelEase, we strive to provide a seamless booking experience for all our customers. However, we understand that plans can change. Below are the terms and conditions for requesting a refund:
                        </Typography>
                        <Box component="ul" sx={{ pl: 2 }}>
                            <Typography component="li" variant="body1">
                                Refunds for flight bookings are subject to the airline's refund policy and cancellation fees.
                            </Typography>
                            <Typography component="li" variant="body1">
                                Hotel bookings can be refunded if canceled at least 48 hours prior to the check-in date. Cancellation charges may apply.
                            </Typography>
                            <Typography component="li" variant="body1">
                                Tour packages are eligible for refunds if canceled 7 days prior to the start date. Custom packages may have different terms.
                            </Typography>
                            <Typography component="li" variant="body1">
                                Refund requests must include your booking ID and proof of payment.
                            </Typography>
                        </Box>
                        <Typography variant="body1" gutterBottom>
                            Refunds will be processed within 10-14 business days after your request is approved. Please note that transaction fees are non-refundable.
                        </Typography>
                        <Typography variant="body1" gutterBottom>
                            If you have any questions or concerns regarding your refund, please reach out to our customer service team at update@gmail.com or call us at +1-000-000-000.
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            Note: Refund policies may vary depending on the service provider's terms and conditions.
                        </Typography>
                    </Paper>
                </Container>
            </Box>
            <Footer />
        </Box>
    );
}

export default RefundPolicy;
